import React, { useState } from "react";
import { Pagination } from "react-bootstrap";

export const PICKER_PAGE_SIZE = 24;

export function usePickerPage(
  items,
  filterKey,
  pageSize = PICKER_PAGE_SIZE,
  initialPage = 1
) {
  const [selection, setSelection] = useState({
    key: filterKey,
    page: initialPage
  });
  if (selection.key !== filterKey) {
    setSelection({ key: filterKey, page: initialPage });
  }
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const page =
    selection.key === filterKey
      ? Math.min(selection.page, pageCount)
      : Math.min(initialPage, pageCount);
  return {
    page,
    pageCount,
    pageItems: items.slice((page - 1) * pageSize, page * pageSize),
    setPage: (next) => setSelection({ key: filterKey, page: next })
  };
}

export default function PickerPagination({ page, pageCount, setPage }) {
  if (pageCount <= 1) return null;
  const first = Math.max(1, Math.min(page - 2, pageCount - 4));
  const pages = Array.from(
    { length: Math.min(5, pageCount) },
    (_, index) => first + index
  );
  return (
    <Pagination className="mb-0 flex-wrap justify-content-center">
      <Pagination.First disabled={page === 1} onClick={() => setPage(1)} />
      <Pagination.Prev
        disabled={page === 1}
        onClick={() => setPage(page - 1)}
      />
      {pages.map((number) => (
        <Pagination.Item
          key={number}
          active={page === number}
          onClick={() => setPage(number)}
          aria-label={String(number)}
        >
          {number}
        </Pagination.Item>
      ))}
      <Pagination.Next
        disabled={page === pageCount}
        onClick={() => setPage(page + 1)}
      />
      <Pagination.Last
        disabled={page === pageCount}
        onClick={() => setPage(pageCount)}
      />
    </Pagination>
  );
}
